import React from "react";
import ReactChildrenProps from "../../generalTypes/ReactChildrenProps";

const MainContentScroll = function(props: ReactChildrenProps) {
  return <div className="overflow-auto flex-grow-1 p-3">{props.children}</div>;
};

export default MainContentScroll;
